import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { BTAlertTypeInsertRequest } from "../shared/BTAlertTypeInsertRequest";
import { BTAlertTypeUpdateRequest } from "../shared/BTAlertTypeUpdateRequest";
import { DataService_BusTrackerAlertType } from "../shared/data.service";
import { IntStringRequest } from "../shared/IntStringRequest";

@Component({
	selector: "app-bus-alert-type-modify",
	templateUrl: "./bus-alert-type-modify.component.html",
	styleUrls: ["./bus-alert-type-modify.component.css"],
})
export class BusAlertTypeModifyComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private AlertTypeService: DataService_BusTrackerAlertType
	) {}

	ngOnInit(): void {
		this.EditMode = this.dialogConfig.data.EditMode;

		if (this.EditMode == true) {
			this.AlertTypeID = this.dialogConfig.data.AlertTypeID;
			this.AlertTypeCD = this.dialogConfig.data.AlertTypeCD;
			this.AlertTypeDesc = this.dialogConfig.data.AlertTypeDesc;
			this.Severity = this.dialogConfig.data.Severity;
		}
	}

	//////////////////////////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////////////////////////

	Processing: any = false;

	EditMode: any = false;
	AlertTypeID: any = -1;
	AlertTypeCD: any = "";
	AlertTypeDesc: any = "";
	Severity: any = 3;
	lstSeverity: any = [
		{
			ID: 3,
			Desc: "Low",
		},
		{
			ID: 2,
			Desc: "Medium",
		},
		{
			ID: 1,
			Desc: "High",
		},
	];

	errorMessage: any = "";

	//////////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		if (this.AlertTypeCD == "") {
			this.errorMessage = "Enter an Alert Type Code";
			return;
		}
		if (this.AlertTypeDesc == "") {
			this.errorMessage = "Enter an Alert Type Name/Description";
			return;
		}

		if (this.AlertTypeCD.length > 10) {
			this.errorMessage = "Alert Type Code must be <= 20 characters";
			return;
		}
		if (this.AlertTypeDesc.length > 100) {
			this.errorMessage = "Alert Type Name/Description must be <= 100 characters";
			return;
		}

		this.Processing = true;

		this.CheckCDInUse();
	}

	CheckCDInUse() {
		let parms: IntStringRequest = {
			num: this.AlertTypeID == undefined ? -1 : this.AlertTypeID,
			str: this.AlertTypeCD,
		};

		var result = this.AlertTypeService.AlertTypeCDInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.Processing = false;

					//Fail Dialog
					this.confirmationService.confirm({
						key: "modifyerror",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Alert Type code already used",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				} else {
					// this.CheckDescInUse();

					if (this.EditMode == false) {
						this.FinishAdd();
					} else {
						this.FinishUpdate();
					}
				}
			},
			(error) => {}
		);
	}

	// CheckDescInUse(){

	//   let parms: IntStringRequest =
	//   {
	//     num: this.AlertTypeID == undefined ? -1 : this.AlertTypeID,
	//     str: this.AlertTypeDesc
	//   }

	//   var result = this.AlertTypeService.AlertTypeDescInUse(parms);
	//   result.subscribe(
	//     response => {
	//       if(response){
	//         this.Processing = false;

	//         //Fail Dialog
	//         this.confirmationService.confirm(
	//         {
	//           key: "modifyerror",
	//           acceptLabel: "Ok",
	//           rejectVisible: false,
	//           message: "Alert Type description already used",
	//           header: "ERROR",
	//           icon: "fa",
	//           accept: () => {
	//           },
	//         });
	//       }
	//       else{
	//         if(this.EditMode == false){
	//           this.FinishAdd();
	//         }
	//         else{
	//           this.FinishUpdate();
	//         }
	//       }
	//     },
	//     error => {
	//     }
	//   )
	// }

	FinishAdd() {
		//
		// Create Request
		//
		let parms: BTAlertTypeInsertRequest = {
			Severity: this.Severity,
			AlertTypeCD: this.AlertTypeCD,
			AlertTypeDesc: this.AlertTypeDesc,
			DefinedByID: 4,
		};

		//
		// Call SP
		//
		var result = this.AlertTypeService.AlertTypeInsert(parms);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Alert Type was created successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not create the Alert Type",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onUpdate() {
		this.errorMessage = "";

		if (this.AlertTypeCD == "") {
			this.errorMessage = "Enter an Alert Type Code";
			return;
		}
		if (this.AlertTypeDesc == "") {
			this.errorMessage = "Enter an Alert Type Name/Description";
			return;
		}

		this.Processing = true;

		this.CheckCDInUse();
	}

	FinishUpdate() {
		//
		// Create Request
		//
		let parms: BTAlertTypeUpdateRequest = {
			AlertTypeID: this.AlertTypeID,
			Severity: this.Severity,
			AlertTypeCD: this.AlertTypeCD,
			AlertTypeDesc: this.AlertTypeDesc,
		};

		//
		// Call SP
		//
		var result = this.AlertTypeService.AlertTypeUpdate(parms);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Alert Type was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Alert Type",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	//////////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.Processing == true;
	}

	//////////////////////////////////////////////////////////////////////////////////
}
